<template>
  <div class="container">
    <h4 class="cardD">Complementa Información</h4>

    <div>
      <b-table ref="table" hover :fields="fieldsCuadro" :items="cotejo.solicitantes">
        <template #cell(nombreCompleto)="{ item }">
          {{ getFullName(item) }}
        </template>
        <template #cell(acciones)="{ item }">
          <b-button
            v-if="cotejo.validaSolicitantes != 1"
            variant="warning"
            size="sm"
            v-b-tooltip.hover
            title="Editar"
            class="editBtn"
            @click="editCompareciente(item)"
          >
            <b-icon-pencil />
          </b-button>
        </template>
        <template #cell(infoCompleta)="{ item }">
          {{ item.infoCompleta ? "✔" : "✖" }}
        </template>
      </b-table>
    </div>

    <div class="mt-4">
      <div class="">
        <b-button
          class="btn-fill orange-btn bottom2"
          size="m"
          @click="checkComparecientes()"
          :disabled="cotejo.validaSolicitantes == 1"
        >
          Continuar
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getFullName } from "@/utils/table-utils";
import { ComparecientesApi } from "@/api";
import { useUIStateStore } from "@/stores";

export default {
  name: "ComplementaSolicitante",

  components: {},

  props: {
    cotejo: { type: Object },
  },

  computed: {
    fieldsCuadro() {
      return [
        { key: "index", label: "", class: "text-center" },
        { key: "nombreCompleto", label: "Nombre", class: "text-center" },
        { key: "persona", label: "Persona", class: "text-center" },
        { key: "infoCompleta", label: "Información completa", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
      ];
    },
  },

  data() {
    return {
      isAllInfoComplete: false,
    };
  },

  setup() {
    const uiStateStore = useUIStateStore();

    return { uiStateStore };
  },

  mounted() {
    this.validateInfo();
  },

  methods: {
    getFullName,

    editCompareciente(item) {
      this.$router.push({
        name: "EditComparecientes",
        params: {
          id: item.id,
        },
        query: {
          proceso: 4,
          procesoId: this.cotejo.id,
          accion: "editcotejo",
        },
      });
    },

    async validateInfo() {
      try {
        this.uiStateStore.startLoading();

        for (let i = 0; i < this.cotejo.solicitantes.length; i++) {
          const solicitante = this.cotejo.solicitantes[i];

          const isValid = await ComparecientesApi.validacion({
            comparecientes_id: solicitante.id,
            tipo: "",
          });

          this.$set(this.cotejo.solicitantes[i], "infoCompleta", isValid);
        }

        this.isAllInfoComplete = this.cotejo.solicitantes.every((solicitante) => solicitante.infoCompleta);
      } catch (error) {
        console.log(error);
      } finally {
        this.uiStateStore.stopLoading();
      }
    },

    checkComparecientes() {
      if (!this.isAllInfoComplete) {
        this.$toast.warning("La información del solicitante no está completa.", {
          timeout: 3000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        return;
      }

      this.$emit("allChecksPassed");
    },
  },
};
</script>
